import { colors } from '@indeed/ifl-tokens';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    sectionItemKey: {
        fontWeight: 'bold',
        fontSize: 14,
        marginBottom: 4,
        display: 'flex',
        alignItems: 'center',
    },
    sectionContentPreferenceMatch: {
        marginLeft: 6,
    },
    tooltipButton: {
        color: colors.neutral[700],
        padding: 0,
        marginLeft: 1,
        verticalAlign: 'bottom',
    },
    informationIcon: {
        height: 16,
        width: 16,
    },
    highlightedAttributes: {
        marginLeft: 0,
    },
});
